import { Component, ReactNode } from "react";

/**
 * Error boundary to catch and suppress errors from MUI's DateRangePicker, such as license watermark errors.
 * This prevents the entire app from crashing due to these non-critical errors.
 * This is only happening locally for now.
 */
class DateRangePickerErrorBoundary extends Component<{ children: ReactNode }> {
  static getDerivedStateFromError() {
    return {};
  }

  componentDidCatch() {
    // Silently catch and suppress MUI license watermark errors
  }

  render() {
    return this.props.children;
  }
}

export default DateRangePickerErrorBoundary;
